import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { Shipment } from "../models/shipment.model";
import { JwtService } from "./jwt.service";

@Injectable()
export class ShipmentService {
    private rootUrl = environment.API_URL;

    getheadersWithAuth() {
        let headerDict = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': 'true',
            'observe': 'response'
        };
        return headerDict;
    }

    reqHeaders = { headers: new HttpHeaders(this.getheadersWithAuth()) };

    constructor(private http: HttpClient,
        private jwtService: JwtService) { }

    getShipment(id: String) {
        return this.http.get<Shipment>(this.rootUrl + '/shipment/get/' + id, this.reqHeaders)
            .pipe(map(
                (data: any) => {
                    return new Shipment().deserialize(data)
                }));
    }

    getShipments() {
        return this.http.get(this.rootUrl + '/shipment/all', this.reqHeaders)
            .pipe(map(
                (data: any) => {
                    const shipments: Shipment[] = new Array()
                    data.map(value => shipments.push(new Shipment().deserialize(value)))
                    return shipments
                }));
    }

    updateShipment(shipment: Shipment) {
        const body = JSON.stringify(shipment)
        return this.http.post(this.rootUrl + '/shipment/update', body, this.reqHeaders)
    }

    deleteShipment(id: string) {
        return this.http.delete(this.rootUrl + '/shipment/delete/' + id, this.reqHeaders)
    }

    createShipment(shipment: Shipment) {
        const body = JSON.stringify(shipment)
        return this.http.post(this.rootUrl + '/shipment/save', body, this.reqHeaders)
    }

    getUTCDate(d: Date): string {
        // Fist convert the date time to GMT 0
        const date = new Date(d.valueOf() + d.getTimezoneOffset() * 60000);
        const year = date.getFullYear(),
            month = (date.getMonth() + 1).toString(),
            formatedMonth = (month.length === 1) ? ('0' + month) : month,
            day = date.getDate().toString(),
            formatedDay = (day.length === 1) ? ('0' + day) : day,
            hour = date.getHours().toString(),
            formatedHour = (hour.length === 1) ? ('0' + hour) : hour,
            minute = date.getMinutes().toString(),
            formatedMinute = (minute.length === 1) ? ('0' + minute) : minute,
            second = date.getSeconds().toString(),
            formatedSecond = (second.length === 1) ? ('0' + second) : second;
        return year + '-' + formatedMonth + '-' + formatedDay + 'T' + formatedHour + ':' + formatedMinute + ':' + formatedSecond + 'Z';
    }
}